import { I18n } from 'i18n-js';
import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import it from './locales/it.json';
import ja from './locales/ja.json';
import pl from './locales/pl.json';
import pt from './locales/pt.json';

/**
 * Web i18n. Locale comes from the browser (navigator.language → language
 * code); anything we don't ship falls back to English.
 *
 * Shipped languages: en, fr, it, ja, pl, pt (pt-PT), es (es-ES).
 * Interpolation uses i18n-js syntax: t('key', { name: value }) with
 * %{name} placeholders in the locale files.
 */
const i18n = new I18n({ en, es, fr, it, ja, pl, pt });
i18n.enableFallback = true;
i18n.defaultLocale = 'en';
i18n.locale = (typeof navigator !== 'undefined' && navigator.language
    ? navigator.language.split('-')[0]
    : 'en');

export const t = (scope: string, options?: Record<string, unknown>): string =>
    i18n.t(scope, options);
export default i18n;
